<template>
  <PainelLayout>
    <Breadcrumb :lista="[ { 'name':'Painel', 'link' : '/' }]" />
    
    <div class="row">
      <div class="col-6">
        <h1>Fornecedores</h1>
      </div>
      <div class="col-6 text-end">
        <router-link to="/supplier/new">
          <button class="btn btn-primary mt-3">Novo fornecedor</button>
        </router-link>
      </div>
    </div>
    <hr/>

    <app-table v-if="!loading" empty-message='nada encontrado'
    :colunas="[{ label: '' }, { label: 'Nome' }, {label: 'Whatsapp'},{label: 'Cidade'}, {label: ''}]">
      <app-trow
        v-for="item in lista" :key="item.id"
        :data="[
          {value: item.id},
          {value: item.name},
          {value: item.phone},
          {value: item.city}
        ]"
      >
      <template #actions>
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/supplier/details', query: { id: item.id } }">
          <i class="bi bi-file-earmark-text me-2"></i>Ver +
        </router-link>
      </template>
      </app-trow>
    </app-table>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive } from 'vue';
import { Modal } from 'bootstrap';
import { supplier } from '@/models/supplier';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

export default {
  name: "SupplierView",
  components: {
    PainelLayout,
    Breadcrumb,AppTable, AppTrow
  },
  setup(props) {

    const toastStore = useToastStore();
    const lista = ref([]);
    const model = supplier();
    const loading = ref(true);

    let modal = '';
    var advancedMode = ref(false);
    const supplierobj = reactive({
      id: null,
      name: ''
    });

    const { isAdmin, isUser, isOpeto } = usePermissions();

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete(item) {
      supplierobj.id = item.id;
      supplierobj.name = item.name;
      openModal('modal_delete');
    }

    function confirmExcluir() {
      model.delet(supplierobj.id).then(() => {
        toastStore.success('Fornecedor excluído com sucesso.');
        closeModal();
        list();
      }).catch((error) => {
        toastStore.error('Erro ao excluir fornecedor: ' + parseError(error));
      });
    }

    async function list() {
      loading.value = true;
      lista.value = await model.list();
      loading.value = false;
    }

    onMounted(() => {
      list();
    });

    return {
      lista,
      advancedMode,
      closeModal,
      openModal,
      showModal_delete,
      confirmExcluir,
      supplierobj,
      isAdmin,
      isUser,
      isOpeto,
      loading
    }
  }
}
</script>